"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.messagesProviderActions = exports.initialState = void 0;
const uniq_1 = __importDefault(require("lodash/uniq"));
const slices_1 = require("../../utils/@reduxjs/slices");
const api_1 = require("../../utils/api");
const toolkit_1 = require("../../utils/@reduxjs/toolkit");
const utils_1 = require("./utils");
const REDUCER_KEY = 'messagesProvider';
exports.initialState = (0, slices_1.getPreloadedState)(REDUCER_KEY, {
    data: {
        fetchItems: api_1.requestInitialState,
        fetchReadMessage: api_1.requestInitialState,
        setReadMessages: api_1.requestInitialState,
        entries: {},
        counts: {
            fetchItems: api_1.requestInitialState,
            data: {},
        },
    },
    layout: {
        notificationsPage: {
            fetchItems: api_1.requestInitialState,
            hasMore: false,
            ids: [],
            pagination: {
                offset: 0,
                limit: 10,
            },
        },
        notificationsPanel: {
            fetchItems: api_1.requestInitialState,
            hasMore: false,
            ids: [],
            pagination: {
                offset: 0,
                limit: 10,
            },
        },
    },
});
const messagesProviderSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        fetchMessagesToGeneral(state, __payload) {
            state.data.fetchItems.loading = true;
            state.data.fetchItems.error = null;
        },
        fetchMessagesToGeneralSuccess(state, { payload }) {
            state.data.fetchItems.loading = false;
            state.data.fetchItems.error = null;
            state.data.entries = {
                ...state.data.entries,
                ...(0, slices_1.toIdsMap)(payload.items.map((item) => ({
                    ...item,
                    isRead: !!item.read_at,
                }))),
            };
        },
        fetchMessagesToGeneralError(state, { payload }) {
            state.data.fetchItems.loading = false;
            state.data.fetchItems.error = payload;
        },
        fetchMessages(state, { payload }) {
            state.layout[payload.layoutType].fetchItems.loading = true;
            state.layout[payload.layoutType].fetchItems.error = null;
        },
        fetchMessageSuccess(state, { payload }) {
            const { items } = payload.resData;
            state.layout[payload.layoutType].fetchItems.loading = false;
            state.layout[payload.layoutType].fetchItems.error = null;
            state.layout[payload.layoutType].hasMore = payload.resData.hasMore;
            state.layout[payload.layoutType].ids = (0, uniq_1.default)([
                ...state.layout[payload.layoutType].ids,
                ...(0, slices_1.toIdsArray)(items),
            ]);
        },
        fetchMessageError(state, { payload }) {
            state.layout[payload.layoutType].fetchItems.loading = false;
            state.layout[payload.layoutType].fetchItems.error = payload.errorData;
        },
        fetchCountNotifications(state) {
            state.data.counts.fetchItems.loading = true;
            state.data.counts.fetchItems.error = null;
        },
        fetchCountNotificationsSuccess(state, { payload }) {
            state.data.counts.fetchItems.loading = false;
            state.data.counts.fetchItems.error = null;
            state.data.counts.data = payload;
        },
        fetchCountNotificationsError(state, { payload }) {
            state.data.counts.fetchItems.loading = false;
            state.data.counts.fetchItems.error = payload;
        },
        clearMessages(state, { payload }) {
            state.layout[payload.layoutType].pagination =
                exports.initialState.layout[payload.layoutType].pagination;
            state.layout[payload.layoutType].ids =
                exports.initialState.layout[payload.layoutType].ids;
        },
        setPaginationPage(state, { payload }) {
            state.layout.notificationsPage.pagination = {
                ...state.layout.notificationsPage.pagination,
                ...payload,
            };
        },
        setPaginationPanel(state, { payload }) {
            state.layout.notificationsPanel.pagination = {
                ...state.layout.notificationsPanel.pagination,
                ...payload,
            };
        },
        setReadMessages(state) {
            state.data.setReadMessages.loading = true;
            state.data.setReadMessages.error = null;
        },
        setReadMessagesSuccess(state) {
            state.data.setReadMessages.loading = false;
            state.data.setReadMessages.error = null;
            state.data.entries = (0, utils_1.changeNotificationIsRead)(state.data.entries);
        },
        setReadMessagesError(state, { payload }) {
            state.data.setReadMessages.loading = false;
            state.data.setReadMessages.error = payload.errorData;
        },
        setReadMessage(state, { payload }) {
            state.data.fetchReadMessage.loading = true;
            state.data.fetchReadMessage.error = null;
            state.data.entries[payload.messageId].isRead = true;
        },
        setReadMessageSuccess(state) {
            state.data.fetchReadMessage.loading = false;
            state.data.fetchReadMessage.error = null;
        },
        setReadMessageError(state, { payload }) {
            state.data.fetchReadMessage.loading = false;
            state.data.fetchReadMessage.error = payload.errorData;
            state.data.entries[payload.messageId].isRead = false;
        },
    },
});
exports.messagesProviderActions = messagesProviderSlice.actions, exports.reducer = messagesProviderSlice.reducer, exports.sliceKey = messagesProviderSlice.name;
//# sourceMappingURL=slice.js.map